import { Directive, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges, ViewContainerRef, inject } from '@angular/core';

import { ComponentLoaderComponent } from './component-loader.component';
import { ComponentProxy } from './component-loader.service';

@Directive({
    selector: '[msComponentProxy]',
})
export class ComponentProxyDirective implements OnDestroy, OnChanges {
    private viewRef = inject(ViewContainerRef);

    @Output() componentLoaded = new EventEmitter<void>();

    @Input() msComponentProxyLoader?: boolean;
    @Input() msComponentProxy: ComponentProxy<unknown> | undefined;

    ngOnChanges(changes: SimpleChanges) {
        if (changes.msComponentProxy) {
            this.destroy();

            if (this.msComponentProxyLoader !== false) {
                this.viewRef.createComponent(ComponentLoaderComponent);
            }

            this.msComponentProxy?.create(this.viewRef).subscribe(() => this.componentLoaded.next());
        }
    }

    ngOnDestroy(): void {
        this.destroy();
    }

    private destroy(): void {
        this.msComponentProxy?.destroy();
        this.viewRef.clear();
    }
}
